import { parse } from "query-string";
import { useEffect } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useLanguages } from "../../../../utils/hooks/useLanguages";
import { usePaymentResult } from "../../../modules/payment/Payment/components/PaymentResult/hooks/usePaymentResult";

export const useFlywireCallback = () => {
  const navigate = useNavigate();
  const { paymentPlanLineId } = useParams();
  const { navigateToPaymentPlanLineView } = usePaymentResult(paymentPlanLineId);
  const { setLanguage } = useLanguages();

  const searchParams = parse(location.search);
  const { reference, status } = searchParams;

  useEffect(() => {
    if (!paymentPlanLineId) return;
    if (!reference || !status) {
      // Return to payment view when reloading window
      // (parameters have been previously removed)
      navigateToPaymentPlanLineView();
      return;
    }
    setLanguage();
    // Remove parameters from url
    navigate(".", { replace: true });
  }, []);

  return { paymentPlanLineId };
};
